/**
 * Created by Christof Sander on 20.02.2017.
 */

const utils = require('../../lib/utils')

module.exports = {
	config: {
		transition: {
			duration: .3,
			ease: (Cubic || {}).easeInOut
		},
		ttl: 3,
		environmentDependent: true,
		outerPanelHeight: 5,			// [em]
		outerPanelHeightByEnvironmentStyle: {
			mobile: 5,					// [em]
			desktop: 5,					// [em]
		},
		statusDelay: .4,                // prevent jitter on show [s]
		statusMinShowTime: 1,           // prevent jitter on hide [s]
		focusAble: true,
		focusPriorityBase: 1500,
		staticLookupName: 'statusController'
	},

	model: {
		nrOfPanels: 0,
		nrOfActivePanels: 0,
		nrOfActiveStatus: 0,
		statusActivity: false,
		showTimeout: null,
		statusHideBlocked: false,
		freeToHide: false,
		panelTimeouts: {}
	},

	events: {
		// prevent all controll key actions
		keyboard: {
			type: 'keydown',
			action: function(event) {
				switch (utils.keyboard.getKeyCode(event)) {
					case 'enter':
					case 'esc':
						event.preventDefault();
						event.stopImmediatePropagation();
						break;
				}
			}
		}
	},

	methods: {
		////////////////////////////
		///// MISC FUNCTIONALITY
		////////////////////////////

		/**
		 * environment has been updated (resize)
		 */
		onEnvironmentUpdated: function(){
			const environmentStyle = (this.activeEnvironment || {}).style
			if(environmentStyle !== this.model.environmentStyle){
				this.model.environmentStyle = environmentStyle
				this.config.outerPanelHeight = (this.config.outerPanelHeightByEnvironmentStyle || {})[environmentStyle] || this.config.outerPanelHeight || 5
			}
		},



		////////////////////////////
		///// BASE FUNCTIONALITY
		////////////////////////////

		/**
		 * shows the status controller
		 * NOTE: delayed if necessary (prevent jitter on showStatus)
		 *
		 * @param   panelActivity       boolean - panelActivity
		 * @param   statusActivity      boolean - statusActivity
		 */
		show: function(panelActivity, statusActivity){
			if(!this.model.showTimeout && statusActivity && !this.model.statusActivity){
				this.model.showTimeout = setTimeout(function(self){
					self.model.delayedShowStart = new Date().getTime();
					self._show(false, true);
				}, this.config.statusDelay * 1000, this);
			}
			if(panelActivity) {
				this._show(true);
			}
		},

		/**
		 * this function is used for the real show operations without any delay.
		 * NOTE: this is an internal function which must not be used from outerside.
		 *
		 * @param   panelActivity       boolean - panelActivity
		 * @param   statusActivity      boolean - statusActivity
		 * @private
		 */
		_show: function(panelActivity, statusActivity){
			if(panelActivity){
				this.$.addClass('panelsVisible');
			}
			if(statusActivity){
				this.config.focusPriority = this.config.focusPriorityBase
				this.$.addClass('statusVisible');
				delete this.model.showTimeout;
				this.model.statusActivity = true;
				this.model.statusHideBlocked = true;
				setTimeout(function(self){
					self.model.statusHideBlocked = false;
					if(self.model.freeToHide){
						self.hide(self.model.nrOfActivePanels <= 0, self.model.nrOfActiveStatus <= 0);
					}
				}, this.config.statusMinShowTime * 1000, this);

				TweenMax.to(
					this.model.$statusContainer,
					this.config.transition.duration,
					{
						opacity: 1,
						ease: this.config.transition.ease
					}
				);
			}

		},

		/**
		 * hide the status controller
		 *
		 * @param   hidePanelContainer       boolean
		 * @param   hideStatusContainer      boolean
		 */
		hide: function(hidePanelContainer, hideStatusContainer){
			var self = this;
			if(this.model.showTimeout){
				clearTimeout(this.model.showTimeout);
				delete this.model.showTimeout;
			}

			if(hideStatusContainer){
				if(this.model.statusHideBlocked){
					this.model.freeToHide = true
				}
				else {
					// the focusPriority has to be high only in cases the statusContainer is shown.
					// if just a panel is shown the statusController should have no focusPriority.
					delete this.config.focusPriority
					var statusActivity = this.model.statusActivity
					this.model.statusActivity = false

					TweenMax.to(
						self.model.$statusContainer,
						self.config.transition.duration,
						{
							opacity:    0,
							ease:       self.config.transition.ease,
							onComplete: function(){
								self.$.removeClass('statusVisible');

								if(statusActivity){
									self.updatePanelContainerHeight();
									globalThis.componentTree.focusRightComponent();
								}
							}
						}
					);
				}
			}

			if(hidePanelContainer && self.$.hasClass('panelsVisible')){
				self.model.nrOfActivePanels = 0;
				self.model.nrOfPanels = 0;
				self.model.$panelContainer.html('');
				self.$.removeClass('panelsVisible');
				self.updatePanelContainerHeight();
			}
		},

		/**
		 * the user is not allowed to interact with anything of the gui
		 */
		block: function(){
			this.$.addClass('blocking').focus();
		},

		/**
		 * the user is allowed to interact with the gui
		 */
		free: function(){
			this.$.removeClass('blocking');
			globalThis.componentTree.focusRightComponent();
		},



		////////////////////////////
		///// PANEL FUNCTIONALITY
		////////////////////////////

		/**
		 * add panel containing the given message and show the status controller if necessary
		 *
		 * @param   message                         string - panel message
		 * @param   [preventMessageTranslation]     boolean - if this flag is set to true the given message will be treated as already translated. otherwise it will be translated by i18next.
		 * @param 	[ttl]							number - time to live in seconds
		 * @param 	[styleClass]					string - additional css class used for panelContainer and statusMessage
		 * @returns Component - self
		 */
		addPanel: function(message, preventMessageTranslation, ttl, styleClass){
			this.model.nrOfPanels++;
			this.model.nrOfActivePanels++;

			if(!preventMessageTranslation) message = storage.__(message);
			var self = this;
			self.show(true);
			var usedTTL = (ttl || this.config.ttl) * 1000;

			// close panel
			setTimeout(function(self){
				self.reducePanels();
			}, usedTTL, this);

			// handle panelContainer style removal
			var timeoutClass = styleClass || '____default____';
			if(self.model.panelTimeouts[timeoutClass]) {
				clearTimeout(self.model.panelTimeouts[timeoutClass]);
				delete self.model.panelTimeouts[timeoutClass];
			}
			self.model.panelTimeouts[timeoutClass] = setTimeout(function(self, styleClass){
				self.model.$panelContainer.removeClass(styleClass);
			}, (usedTTL + (self.config.transition.duration * 1000)), self, styleClass);

			this.model.$panelContainer.addClass(styleClass);
			this.model.$panelContainer.append(this.include('./status', { model: { message: message, styleClass }}));

			this.updatePanelContainerHeight();

			return this;
		},

		/**
		 * reduce the panel list by the oldest one
		 */
		reducePanels: function(){
			var self = this;
			this.model.nrOfActivePanels--;

			if(this.model.nrOfActivePanels <= 0){
				this.model.nrOfActivePanels = 0;
				this.removePanel(function(){
					self.hide(true, self.model.nrOfActiveStatus <= 0);
				});
			}
			else {
				this.removePanel();
			}
		},

		/**
		 * remove the oldest panel
		 *
		 * @param   onRemoveCallback        function - optional - callback when remove has been animated
		 * @returns Component - self
		 */
		removePanel: function(onRemoveCallback){
			var $status;
			if(($status = this.model.$panelContainer.find('.base_statusController_status:not(.removeing):first').addClass('removeing')).length > 0){
				TweenMax.to(
					$status,
					this.config.transition.duration,
					{
						opacity: 0,
						ease: this.config.transition.ease,
						onComplete: function(){
							if(typeof(onRemoveCallback) === 'function'){
								onRemoveCallback();
							}
						}
					}
				);
			}

			return this;
		},

		/**
		 * animate and update panel container height
		 */
		updatePanelContainerHeight: function(){
			TweenMax.to(
				this.model.$panelContainer,
				this.config.transition.duration,
				{
					height: (this.model.nrOfPanels * this.config.outerPanelHeight) + 'em'
				}
			);
		},



		////////////////////////////
		///// STATUS FUNCTIONALITY
		////////////////////////////

		/**
		 * show centered status message
		 *
		 * @param   message                         string - status message
		 * @param   preventMessageTranslation       boolean - if this flag is set to true the given message will be treated as already translated. otherwise it will be translated by i18next.
		 * @returns Component - self
		 */
		showStatus: function(message, preventMessageTranslation){
			var self = this;
			self.model.nrOfActiveStatus++;
			if(!preventMessageTranslation) message = storage.__(message);
			self.show(false, true);
			var $newStatus = $(this.include('./status', { model: { message: message }}));
			var $oldPanels = self.model.$statusContent.find('.base_statusController_status');
			self.model.$statusContent.append($newStatus);
			TweenMax.to(
				$oldPanels,
				self.config.transition.duration,
				{
					ease: self.config.transition.ease,
					opacity: 0,
					onComplete: function(){
						$oldPanels.remove();
						TweenMax.to(
							$newStatus,
							self.config.transition.duration,
							{
								ease: self.config.transition.ease,
								opacity: 1
							}
						);
					}
				}
			);

			return this;
		},

		/**
		 * each status has to be removed.
		 * NOTE:    this is not used for displaying the right message.
		 *          instead it is used to hide the status controller when and only when all shown status has been removed.
		 *
		 * @params  boolean - errorHandlingInCharge
		 * @returns Component - self
		 */
		removeStatus: function(errorHandlingInCharge){
			if(errorHandlingInCharge){
				this.model.nrOfActiveStatus = 0;
			}
			else {
				this.model.nrOfActiveStatus--;
			}
			this.hide(this.model.nrOfActivePanels <= 0 && this.model.nrOfActiveStatus <= 0, this.model.nrOfActiveStatus <= 0);
			return this;
		}

	},

	hooks: {
		attach: function($element, options){
			this.model.$statusContainer     = $element.find('.statusContainer');
			this.model.$statusContent       = this.model.$statusContainer.find('.content');
			this.model.$panelContainer      = $element.find('.panelContainer');
		}
	}
};
